import React from "react";
import { Link } from "react-router-dom";
import Footer from "../../Components/Footer";
import Header from "../../Components/Header";

function Sellerforget() {
  return (
    <>
      <Header />
      {/* Seller Forget Sec */}
      <section className="seller-forget-sec">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="seller-forget-form">
                <form>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="seller-forget-input">
                        <div className="seller-forget-head">
                          <h3>enter your email</h3>
                        </div>
                        <input type="text" />
                        <p>
                          An Email Has Been Sent To Reset The Password Haven't
                          Received The Email Yet? Try Again
                        </p>
                        <div className="seller-forget-btn">
                          <Link to="/seller-otp">send</Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* ================== */}
      <Footer />
    </>
  );
}

export default Sellerforget;
